module.exports = __webpack_public_path__ + "img/package_2.2f081c84.png";